import api from './client';

export async function fetchUsers(authConfig = {}) {
  const { data } = await api.get('/api/users', authConfig);
  return data;
}

export async function fetchUserById(id, authConfig = {}) {
  const { data } = await api.get(`/api/users/${id}`, authConfig);
  return data;
}

export async function createUser(body, authConfig = {}) {
  const { data } = await api.post('/api/users', body, authConfig);
  return data;
}

export async function updateUser(id, body, authConfig = {}) {
  const { data } = await api.put(`/api/users/${id}`, body, authConfig);
  return data;
}

export async function deleteUser(id, authConfig = {}) {
  await api.delete(`/api/users/${id}`, authConfig);
}
